// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as EventTracker from "../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as AdjustFareDataMachine from "../../../app/repo/AdjustFareDataMachine.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";
import * as AdjustFareUpdatePayloadGenerator from "../../../app/api-model/payload-generator/AdjustFareUpdatePayloadGenerator.bs.js";

function AdjustFareFooter(Props) {
  var currency_symbol = Props.currency_symbol;
  var current_fare_details = Props.current_fare_details;
  var new_fare_details = Props.new_fare_details;
  var form_duration_selector = Props.form_duration_selector;
  var is_submit_button_enabled = Props.is_submit_button_enabled;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var getAmountWithSymbol = function (amount) {
    return currency_symbol + " " + Currency.fromCurrency(amount).toFixed(2);
  };
  var disableAdjustFarePost12hrsforTR;
  disableAdjustFarePost12hrsforTR = country.TAG === /* TR */3 ? Timestamp$Catalyst.isAfter(Timestamp$Catalyst.now(undefined), Timestamp$Catalyst.getDateTimeAfterElapsedTime(12.0, /* Hours */5, current_fare_details.data.end_time)) : false;
  return React.createElement("div", {
              className: "c-adjust-fare-details-action"
            }, React.createElement("div", {
                  className: "final-fair-wrapper"
                }, React.createElement("p", {
                      className: "final-fare-text"
                    }, "Total"), React.createElement("div", {
                      className: "final-fare-value-wrapper"
                    }, Currency.fromCurrency(current_fare_details.data.order_fare.fare) - Currency.fromCurrency(new_fare_details.data.order_fare.fare) === 0.00 ? React.createElement(React.Fragment, undefined, React.createElement("p", {
                                className: "current-fare-value"
                              }, getAmountWithSymbol(current_fare_details.data.order_fare.fare))) : React.createElement(React.Fragment, undefined, React.createElement("p", {
                                className: "current-fare-value-striked"
                              }, getAmountWithSymbol(current_fare_details.data.order_fare.fare)), React.createElement("p", {
                                className: "final-fare-value"
                              }, getAmountWithSymbol(new_fare_details.data.order_fare.fare))))), React.createElement("div", {
                  className: "adjust-fare-details-action-buttons-wrapper"
                }, React.createElement("div", {
                      className: "adjust-fare-reset-button-wrapper"
                    }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Custom */1,
                                _0: (function (param) {
                                    return React.createElement("p", {
                                                className: "adjust-fare-update-reset-button-text"
                                              }, "Reset");
                                  })
                              }, undefined, (function (param) {
                                  return Curry._1(dispatch, {
                                              TAG: /* ResetChanges */7,
                                              reset_form: true
                                            });
                                }), undefined, undefined, undefined, undefined, "adjust-fare-reset-button", undefined, undefined)
                        })), React.createElement("div", {
                      className: "adjust-fare-submit-button-wrapper"
                    }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Custom */1,
                                _0: (function (param) {
                                    return React.createElement("p", {
                                                className: is_submit_button_enabled ? "adjust-fare-enabled-submit-button-text" : "adjust-fare-disabled-submit-button-text"
                                              }, "Adjust Fare");
                                  })
                              }, !is_submit_button_enabled, (function (param) {
                                  if (disableAdjustFarePost12hrsforTR) {
                                    return Curry._1(dispatch, {
                                                TAG: /* OpenSnackbar */3,
                                                snackbar_message: {
                                                  TAG: /* Error */1,
                                                  _0: "Adjusting the fare is not allowed 12 hours after the trip has ended"
                                                }
                                              });
                                  } else {
                                    var payload = AdjustFareUpdatePayloadGenerator.execute(new_fare_details, form_duration_selector);
                                    Curry._1(dispatch, {
                                          TAG: /* UpdateNewFareDetails */2,
                                          new_fare_datails: {
                                            TAG: /* Loading */0,
                                            _0: new_fare_details
                                          }
                                        });
                                    return AdjustFareDataMachine.updateFare(payload, (function (success_response) {
                                                  Curry._1(dispatch, {
                                                        TAG: /* SetCurrentFare */1,
                                                        current_fare_details: {
                                                          TAG: /* Live */1,
                                                          _0: new_fare_details
                                                        }
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: /* UpdateNewFareDetails */2,
                                                        new_fare_datails: {
                                                          TAG: /* Live */1,
                                                          _0: new_fare_details
                                                        }
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: /* UpdateFormDurationSelector */0,
                                                        form_duration_selector: /* Mins */0
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: /* UpdatePreviewButtonStatus */6,
                                                        is_preview_fare_button_enabled: false
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: /* UpdateSubmitButtonStatus */5,
                                                        is_submit_button_enabled: false
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: /* OpenSnackbar */3,
                                                        snackbar_message: {
                                                          TAG: /* Success */0,
                                                          _0: success_response.message
                                                        }
                                                      });
                                                  return EventTracker.publishEvent({
                                                              category: "Adjust Fare",
                                                              action: "New Adjust Fare Submit Successful",
                                                              label: "Random",
                                                              value: undefined,
                                                              nonInteraction: undefined
                                                            });
                                                }), (function (error) {
                                                  Curry._1(dispatch, {
                                                        TAG: /* UpdateNewFareDetails */2,
                                                        new_fare_datails: {
                                                          TAG: /* Live */1,
                                                          _0: new_fare_details
                                                        }
                                                      });
                                                  Curry._1(dispatch, {
                                                        TAG: /* OpenSnackbar */3,
                                                        snackbar_message: {
                                                          TAG: /* Error */1,
                                                          _0: ErrorUtils$Catalyst.resolveError(error)
                                                        }
                                                      });
                                                  return EventTracker.publishEvent({
                                                              category: "Adjust Fare",
                                                              action: "New Adjust Fare Submit Failure",
                                                              label: "Random",
                                                              value: undefined,
                                                              nonInteraction: undefined
                                                            });
                                                }), country);
                                  }
                                }), undefined, undefined, undefined, undefined, is_submit_button_enabled ? "adjust-fare-submit-button-enabled" : "adjust-fare-submit-button-disabled", undefined, undefined)
                        }))));
}

var make = AdjustFareFooter;

export {
  make ,
  
}
/* react Not a pure module */
